<template>
    <main>
        <div class="container feedback template-bg-gray" v-bind:class="{'my-position-relative': isStatus}">
        <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-html="statusMsg"></h4>
                </div>
            </md-card-content>
        </md-card>
        <template>
            <snackbar ref="snackbar" baseSize="100px" :position="'top-center'" :wrapClass="''" :colors="{open: '#3DBD7D'}" :holdTime="5000" :multiple="false"/>
        </template>
        <div class="row" v-if="!isStatus">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common" v-bind:class="{'emailreq-ty': success}">
                    <div class="card form-wrapper">
                        <div class="feedback_container feedback_newupdate">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <img :src="logoURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 common-space-from-logo">
                                    <div class="text-center" v-show="!success">
                                        <div v-if="memberid !== 'undefined' && (typeof memberid !== 'undefined') && memberid !== 'null' && memberid !== ''">
                                            <h2 class="template-title">Know someone else who could help?</h2>
                                            <p class="custom-content my-text-center">Please let us know below and we will forward the request on your behalf.
                                                Note that we will not use your contact's information for any other purposes.</p>
                                        </div>
                                    </div>
                                    <div v-if="(success && action == 'yes') || (successReferral == true && action == 'no') || (success && successReferral === false && action == 'no' && (memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''))"  class='header-text text-center unsubscribepage-thankumsg' v-bind:class="{'email-actionpage-tmsg': !success}">
                                        <h1 class="template-title mt-0">Thank you!</h1>
                                        <div v-if="this.memberid !== 'undefined' && (typeof this.memberid !== 'undefined') && this.memberid !== 'null' && this.memberid !== '' && !emailUpdate">
                                            <div v-if="isProfileValidation && !isEmailSection && isUpdateProfileFlag" v-click-outside="outside">
                                                <p class="custom-content">We matched you to this request based on the below  information. Is this still correct?</p>
                                                <p class="custom-content" v-if="adviser.profileValidationFlag == configureFields.profileUpdateInterest">Please choose (or remove) interests that we may use to match you to relevant requests.</p>
                                                <div class="" v-bind:class = "(adviser.profileValidationFlag == configureFields.profileUpdateInterest)?'interest-div':'emailreq-profileupdate'">
                                                    <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateOccupation">
                                                        <!--div v-if = "!isEditing">
                                                            <div class="row">
                                                                <div class="col-lg-2 col-sm-3 update-profile-response-label">Role:</div>
                                                                <div class="col-lg-10 col-sm-9 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.memberRoles ? memberObj.memberRoles: 'N/A'}}</b> </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-sm-3 update-profile-response-label">Organization:</div>
                                                                <div class="col-lg-10 col-sm-9 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.organization ? memberObj.organization: 'N/A'}}</b> </div>
                                                            </div>
                                                        </div-->
                                                        <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                            <div class="row">
                                                                <div class="col-lg-2 col-sm-3 update-profile-response-label">Role:</div>
                                                                <div class="col-lg-10 col-sm-9">
                                                                    <md-field class="profileValidation">
                                                                        <md-input class="d-block-w-100 update-profile-template-input" @input="saveChanges" v-focus v-model="memberObj.memberRoles" name="memberRoles" aria-label="Role"></md-input>
                                                                         <div id="role-description" class="sr-only">
                                                                             Please enter your role.
                                                                         </div>
                                                                     </md-field>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-sm-3 update-profile-response-label">Organization:</div>
                                                                <div class="col-lg-10 col-sm-9">
                                                                    <md-field class="profileValidation">
                                                                        <md-input class="d-block-w-100 update-profile-template-input" aria-describedby="org-description" @input="saveChanges" v-model="memberObj.organization" name="organization" aria-label="Organization"></md-input>
                                                                         <div id="org-description" class="sr-only">
                                                                             Please enter your organization name.
                                                                         </div>
                                                                     </md-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mb-0" v-if="adviser.profileValidationFlag == configureFields.profileUpdateInterest">
                                                        <div class="row text-center my">
                                                            <template v-for="randomInterestItem in randomInterest">
                                                                <div class="col-md-4 col-sm-4 col-xs-6 width100" v-bind:key="randomInterestItem">
                                                                    <md-checkbox class="my-round-checkbox" :key="randomInterestItem" v-model="selectedInterestList" :value="randomInterestItem" :name="randomInterestItem">{{randomInterestItem}}<md-tooltip md-direction="right">{{randomInterestItem}}</md-tooltip></md-checkbox>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateGeography">
                                                        <!--div v-if = "!isEditing">
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">City:</div>
                                                                <div class="col-lg-10 col-xs-9 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.city ? memberObj.city: 'N/A'}}</b> </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">State:</div>
                                                                <div class="col-lg-10 col-xs-9 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.state ? memberObj.state: 'N/A'}}</b> </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">Country:</div>
                                                                <div class="col-lg-10 col-xs-9 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.country ? memberObj.country: 'N/A'}}</b> </div>
                                                            </div>
                                                        </div-->
                                                        <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">
                                                                    <label for="city-input-share">City:</label>
                                                                </div>
                                                                <div class="col-lg-10 col-xs-9">
                                                                    <md-field class="profileValidation">
                                                                        <md-input id="city-input-share" class="d-block-w-100 update-profile-template-input" aria-describedby="city-description" @input="saveChanges" v-focus v-model="memberObj.city" name="city" aria-label="City"></md-input>
                                                                            <div id="city-description" class="sr-only">
                                                                                Please enter your city.
                                                                            </div>
                                                                        </md-field>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">
                                                                    <label for="state-input-share">State:</label>
                                                                </div>
                                                                <div class="col-lg-10 col-xs-9">
                                                                    <md-field class="profileValidation">
                                                                        <md-input id="state-input-share" class="d-block-w-100 update-profile-template-input" @input="saveChanges" aria-describedby="state-description" v-model="memberObj.state" name="state" aria-label="State"></md-input>
                                                                             <div id="state-description" class="sr-only">
                                                                                 Please enter your state.
                                                                             </div>
                                                                         </md-field>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-2 col-xs-3 update-profile-response-label width100">
                                                                    <label for="country-input-share">Country:</label>
                                                                </div>
                                                                <div class="col-lg-10 col-xs-9">
                                                                    <md-field class="profileValidation">
                                                                        <md-input id="country-input-share" class="d-block-w-100 update-profile-template-input" @input="saveChanges" aria-describedby="country-description" v-model="memberObj.country" name="country" aria-label="Country"></md-input>
                                                                             <div id="country-description" class="sr-only">
                                                                                 Please enter your country.
                                                                             </div>
                                                                         </md-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="adviser.profileValidationFlag == configureFields.profileUpdatePhoneNumber">
                                                        <!--div v-if = "!isEditing">
                                                            <div class="row" style="display: flex;">
                                                                <div class="col-lg-1 col-sm-1 update-profile-response-label width100" style="width: auto; white-space: nowrap;">Phone Number:</div>
                                                                <div class="col-lg-11 col-sm-11 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.phoneNumbers && memberObj.phoneNumbers.length && memberObj.phoneNumbers[0] !== "" ? memberObj.phoneNumbers[0]:'N/A'}}</b> </div>
                                                            </div>
                                                        </div-->
                                                        <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                            <div class="row" style="display: flex;">
                                                                <div class="col-lg-1 col-sm-1 update-profile-response-label width100" style="width: auto; white-space: nowrap;">Phone Number:</div>
                                                                <div class="col-lg-11 col-sm-11">
                                                                    <md-field class="profileValidation">
                                                                        <md-input class="d-block-w-100 update-profile-template-input" aria-describedby="phonenumber-description" @input="saveChanges" v-focus v-model.trim="memberObj.phoneNumbers[0]" name="phoneNumbers" aria-label="Phone Number"></md-input>
                                                                             <div id="phonenumber-description" class="sr-only">
                                                                                 Please enter your phone number.
                                                                             </div>
                                                                         </md-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateLinkedInUrl">
                                                        <!--div v-if = "!isEditing">
                                                            <div class="row" style="display: flex;">
                                                                <div class="col-lg-2 col-sm-2 update-profile-response-label width100" style="width: auto; white-space: nowrap;">LinkedIn Url:</div>
                                                                <div class="col-lg-10 col-sm-10 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.linkedIn ? memberObj.linkedIn : 'N/A'}}</b> </div>
                                                            </div>
                                                        </div-->
                                                        <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                            <div class="row" style="display: flex;">
                                                                <div class="col-lg-2 col-sm-2 update-profile-response-label width100" style="width: auto; white-space: nowrap;">LinkedIn Url:</div>
                                                                <div class="col-lg-10 col-sm-10">
                                                                    <md-field class="profileValidation">
                                                                        <md-input class="d-block-w-100 update-profile-template-input" @input="saveChanges" v-focus v-model="memberObj.linkedIn" name="linkedIn" ></md-input>
                                                                    </md-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--div class="btn-block" v-if = "community.communityPortal=='customer'" >
                                                    <a v-bind:href="community.communitySite" v-bind:style="updateProfileBtn" target="_blank" class="btn btn-lightbg mb_0" @click="clickUpdateProfile()">Update Profile</a>
                                                </div>
                                                <div class="btn-block" v-if = "community.communityPortal=='protopia'">
                                                    <button type="button" v-bind:style="updateProfileBtn" class="btn btn-lightbg mb_0" :disabled="buttonToggle" @click="isEditing ? saveProfile() : editProfile()">{{buttonToggle? "Saved!": "Update Profile"}}</button>
                                                </div-->

                                                <div class="btn-block">
                                                        <button type="button" v-focus v-if="community.communityPortal == 'linkedin'" @click="clickUpdateProfile(true),saveProfile('blank'), updateLinkedinProfile" class="btn linkedin-btn" >Update from LinkedIn</button>
                                                    </div>

                                                    <div class="btn-block">
                                                        <button type="button" v-bind:style="nextCloseBtn" class="btn template-button btn-lightbg" @click="goToNext()">Next</button>
                                                    </div>
                                                <span class="h-54"></span>
                                            </div>
                                            <div v-if="isEmailSection">
                                                <p class="my-text-center">Would you like to adjust how often we ask you for help with requests matching your profile?</p>
                                                <div class="row">
                                                    <div class="col-md-12 text-center">
                                                        <div class="progressbar-block my">
                                                            <ul class="progressbar">
                                                                <li @click="changeEmailFrequency('as often as needed')" v-bind:class="{'success': adviser.frequency == 'as often as needed'}"><div>All</div><div v-if="frequency == 'as often as needed'" class="success-text">(active)</div></li>
                                                                <li @click="changeEmailFrequency('daily')" v-bind:class="{'success': adviser.frequency == 'daily'}"><div>Daily</div><div v-if="frequency == 'daily'" class="success-text">(active)</div></li>
                                                                <li @click="changeEmailFrequency('once a week')" v-bind:class="{'success': adviser.frequency == 'once a week'}"><div>Weekly</div><div v-if="frequency == 'once a week'" class="success-text">(active)</div></li>
                                                                <li @click="changeEmailFrequency('once a month')" v-bind:class="{'success': adviser.frequency == 'once a month'}"><div>Monthly</div><div v-if="frequency == 'once a month'" class="success-text">(active)</div></li>
                                                                <li @click="changeEmailFrequency('once a quarter')" v-bind:class="{'success': adviser.frequency == 'once a quarter'}"><div>Quarterly</div><div v-if="frequency == 'once a quarter'" class="success-text">(active)</div></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn-block">
                                                    <a href="javascript:void(0)" v-bind:style="emailBtn" @click="updateEmailFrequency()" class="btn template-button btn-darkbg mb_0">Submit</a>
                                                </div>
                                                <div class="btn-block">
                                                    <button type="button" v-bind:style="nextCloseBtn" class="btn template-button btn-lightbg" @click="closeBtn()">Close</button>
                                                </div>
                                                <span class="h-54"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="nofeedback" v-show="(successReferral === false && success === false && action === 'no')">
                                <form @submit.prevent="submitReferral('referral')" data-vv-scope="referral" class="template-form">
                                    <div class="row">
                                        <div class="col-sm-4 nofeedback-customspace">
                                            <div class="form-group">
                                                <div>Recipient</div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 nofeedback-customspace mb-17">
                                            <div class="input-group">
                                                <label class="template-label">First Name</label>
                                                <input type="text" autocomplete="given-name" class="form-control input-value" v-model.trim="referral.recipient.firstName" id="referralName" name="recipient_firstname" v-validate="'required'" v-focus @input="e => referral.recipient.firstName = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('referral.recipient_firstname')">{{errors.first('referral.recipient_firstname')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 nofeedback-customspace mb-17">
                                            <div class="input-group">
                                                <label class="template-label">Last Name (required):</label>
                                                <p id="lname-help" class="sr-only">Please enter your last name.</p>
                                                <input aria-describedby="lname-help" type="text" autocomplete="family-name" class="form-control input-value" v-model.trim="referral.recipient.lastName" id="referralName" name="recipient_lastname" v-validate="'required'" v-focus @input="e => referral.recipient.lastName = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('referral.recipient_lastname')">{{errors.first('referral.recipient_lastname')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4 nofeedback-customspace">
                                            <div class="form-group">

                                            </div>
                                        </div>
                                        <div class="col-sm-4 nofeedback-customspace mb-17">
                                            <div class="input-group">
                                                <label class="template-label">Email (required):</label>
                                                <p id="email-help" class="sr-only">Please enter your email.</p>
                                                <input aria-describedby="email-help" type="email" autocomplete="email" class="form-control input-value" v-model.trim="referral.recipient.email" @change="checkMemberStatus(referral.recipient.email)" name="recipient_email" v-validate="'required|email'" @input="e => referral.recipient.email = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('referral.recipient_email')">{{errors.first('referral.recipient_email')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4 nofeedback-customspace">
                                            <div class="form-group">
                                                <div>Your Details</div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 nofeedback-customspace mb-17">
                                            <div class="input-group">
                                                <label class="template-label" for="adviser_name">Name:</label>
                                                <input id="adviser_name" type="text" class="form-control input-value" v-model.trim="referral.adviser.name" name="adviser_name" v-validate="'required'" aria-label="Please enter your name" @input="e => referral.adviser.name = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('referral.adviser_name')">{{errors.first('referral.adviser_name')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 nofeedback-customspace mb-17">
                                            <div class="input-group">
                                                <label class="template-label" for="adviser_email">Email:</label>
                                                <input id="adviser_email" type="text" class="form-control input-value" v-model.trim="referral.adviser.email" name="adviser_email" v-validate="'required|email'"  aria-label="Please enter your email" @input="e => referral.adviser.email = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('referral.adviser_email')">{{errors.first('referral.adviser_email')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4 nofeedback-customspace">
                                            <div class="form-group">
                                                <div>Personal Message</div>
                                            </div>
                                        </div>
                                        <div class="col-sm-8">
                                            <div class="input-group">
                                                <label class="template-label">Message</label>
                                                <div class="template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height">
                                                    <textarea
                                                        aria-label="Referral message textarea, character count available."
                                                        aria-describedby="character-counter-referral"
                                                        class="form-control"
                                                        v-model="referral.message"
                                                        v-on:keyup="countdownReferral"
                                                        rows="7"
                                                        :maxlength="maxReferral"
                                                        name="message"
                                                        v-validate="'required|max:500'"
                                                        @input="e => referral.message = sanitizeInput(e.target.value)"
                                                        placeholder="[Click here to edit]
I help students and alumni...">
                                                    </textarea>
                                                    <p class="error" v-show="errors.has('referral.message')">{{errors.first('referral.message')}}</p>
                                                    <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                        <div id="character-counter-referral"
                                                            aria-live="polite"
                                                            class="char-counter template-subject-counter"
                                                            v-bind:class="{'char-count-error': exceedsMaxCountReferral }"
                                                            >{{remainingCountReferral}}  / 500 <span class="sr-only">characters used out of 500.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12 text-right">
                                                     <p id="submit-info" class="sr-only">This will send the request to the referral you specified.</p>
                                                    <button aria-describedby="submit-info" type="submit" v-bind:style="styleObjectBtn" class="btn template-button submitBtn">Share Request</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <!-- Refferal Form end -->
                            <!-- Requester Detail section -->
                            <div v-if="((success === false && successReferral == false) || (success && successReferral == false && action == 'no'&& (memberid != 'undefined' && typeof memberid != 'undefined' && memberid != 'null' && memberid != '')))">
                                <div class="row my">
                                    <div class="col-md-12">
                                        <h1 class="text-center email-request-title">FYI, here's the request</h1>
                                    </div>
                                </div>
                                <div class="email-request-review">
                                    <div class="template-request-review">
                                        <h2 v-if="createdByMember.first && createdByMember.last">{{ createdByMember.first + ' ' +  createdByMember.last }}</h2>
                                        <h5 v-if="memberSchool">{{ memberSchool }}</h5>
                                        <h6>{{ask.subject}}</h6>
                                        <p class="font-color">{{ask.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo email-actionpage-flogo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="footerLogoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </main>
</template>
<script>
    import API from "../services/API";
    import Snackbar from 'vuejs-snackbar';
    import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeResourceDescription } from '../utils/sanitizer';
    import EventBus from '../assets/js/EventBus';
    import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
    export default {
        props: ["communityId", "memberid", "askid", "action", "share", "recipientEmail"],
        components: {Snackbar},
      data() {
        return {
          api: new API(),
          ask: {},
          community: {},
          createdByMember: {},
          infoHasChanged: false,
          success: false,
          email: '',
          fullPage: true,
          exceedsMaxCount: false,
            referral: {
                recipient: {
                    id: '',
                    firstName: '',
                    lastName: '',
                    email: ''
                },
                adviser: {
                    id: '',
                    name: '',
                    email: ''
                },
                message: "I'm trying to help out someone from {{ community.name }} and thought of you - are you able to help? If so, just click below to respond directly."
            },
            adviser: {},
            exceedsMaxCountReferral: false,
            maxReferral: 500,
            remainingCountReferral: 0,
            successReferral: false,
            giveId: '',
            phoneNo: '',
            showAdvisorFrequncy: true,
            selectedResponse: '',
            styleBtn: {
              colorBackd: '#CBA8E0',
              colorBackdHover: '#9178A0',
              color: '#9178A0',
              colorHover: "#ffffff"
            },
            reviewBtn: {
                border: '1px solid #9178A0',
                color: '#9178A0'
            },
            textError: false,
            memberRoles: '',
            memberskills: '',
            emailUpdate: false,
            isProfileValidation: false,
            // updateProfileBtn: {
            //     background: '#CBA8E0',
            //     color: '#ffffff'
            // },
            emailBtn: {
                background: '#9178A0',
                color: '#ffffff'
            },
            frequency: '',
            memberObj: {},
            isEditing: true,
            advisorThankYou: '',
            isStatus: true,
            statusMsg: '',
            logoURL: "",
            footerLogoURL: "",
            isEmailSection: false,
            referanceInterest: [],
            randomInterest: [],
            memberInterestList: [],
            configureFields: {},
            selectedInterestList: [],
            isUpdateProfileFlag: true,
            enableProfileUpdateList: [],
            buttonToggle: false,
            memberSchool: ''
        };
      },
      directives: {
          'click-outside': {
              bind: function(el, binding, vNode) {
                  // Provided expression must evaluate to a function.
                  if (typeof binding.value !== 'function') {
                      const compName = vNode.context.name
                      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a  function, but has to be`
                      if (compName) { warn += `Found in component '${compName}'` }
                      console.warn(warn)
                  }
                 // Define Handler and cache it on the element
                 const bubble = binding.modifiers.bubble
                 const handler = (e) => {
                     if (bubble || (!el.contains(e.target) && el !== e.target)) {
        	                  binding.value(e)
                      }
                  }
                  el.__vueClickOutside__ = handler
                  // add Event Listeners
                  document.addEventListener('click', handler)
               },
               unbind: function(el, binding) {
                   // Remove Event Listeners
                   document.removeEventListener('click', el.__vueClickOutside__)
                   el.__vueClickOutside__ = null
               }
           }
      },
      computed: {
        styleObjectBtn() {
          return {
            '--styleBtn-color': this.styleBtn.color,
            '--styleBtn-background-color': this.styleBtn.colorBackd,
            '--styleBtn-color--hover': this.styleBtn.colorHover,
            '--styleBtn-background-color--hover': this.styleBtn.colorBackdHover
          };
        },
        nextCloseBtn() {
            return {
                'color': this.styleBtn.color,
                'background-color': this.styleBtn.colorBackd,
                'border': `1px solid ${this.styleBtn.colorBackd}`
            };
        },
        updateProfileBtn() {
            return {
                'background-color': this.buttonToggle ? this.styleBtn.colorBackdHover : this.styleBtn.colorBackd,
                'color': this.styleBtn.colorHover
                // 'margin-left': this.buttonToggle ? "30px" : ""
                // '--styleBtn-color': this.styleBtn.color,
                // '--styleBtn-background-color': this.styleBtn.colorBackd,
                // '--styleBtn-color--hover': this.styleBtn.colorHover,
                // '--styleBtn-background-color--hover': this.styleBtn.colorBackdHover
            };
        }
      },
      created() {
        if (!this.askid) {
        	this.$router.push('/');
        } else if (!this.action || this.action !== 'no') {
            this.$router.push('/');
        } else if (this.share !== 'share') {
            this.$router.push('/');
        } else if (typeof this.memberid == 'undefined' || this.memberid == '') {
            this.$router.push('/');
        }
        this.loadData();
        const dict = {
            custom: {
                recipient_firstname: {
                    required: "Please enter the recipient's first name."
                },
                recipient_lastname: {
                    required: "Please enter the recipient's last name."
                },
                recipient_email: {
                    required: "Please enter the recipient's email.",
                    email: "Please enter a valid email address."
                },
                adviser_name: {
                    required: "Please enter the adviser's name."
                },
                adviser_email: {
                    required: "Please enter the adviser's email.",
                    email: "Please enter a valid email address."
                },
                message: {
                    required: "Please enter a message."
                }
            }
    	  };
    		this.$validator.localize('en', dict);
      },
      methods: {
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
        sanitizeHtmlTemplate(template) {
            return sanitizeHtmlTemplate(template);
        },
        sanitizeResourceDescription(description) {
            return sanitizeResourceDescription(description);
        },
        loadData: async function() {
            this.advisorThankYou = '';
            localStorage.setItem('community_id', this.communityId);
            await this.$nextTick(); // Ensure localStorage is committed before API calls
            await this.api.get(`asks/${this.askid}`).then(async ask => {
                if (ask.data) {
                    this.ask = ask.data;
                    this.ask.text = this.ask.text.replace(/\n{1,}/g, '\n\n');
                    if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
                        // console.log("this.community :", this.ask.community);
                        let closeMessage = this.ask.community.content.closeRequestMessage;
                        this.statusMsg = closeMessage;
        			} else {
                        this.isStatus = false;
                    }
                    this.community = this.ask.community;
                    if (this.community.customSettings && this.community.customSettings.faviconURL !== 'none') {
                        console.log('ShareRequest: Emitting favicon change', this.community.customSettings.faviconURL);
                        EventBus.$emit('change-favicon', this.community.customSettings.faviconURL);
                    }
                    const customSettings = this.community.customSettings;
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                    this.configureFields = this.community.content.configureFields;
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateOccupation);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateInterest);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateGeography);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdatePhoneNumber);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateLinkedInUrl);
                    this.enableProfileUpdateList = this.enableProfileUpdateList.sort();
                    this.enableProfileUpdateList = this.enableProfileUpdateList.filter(e => e !== 0)
                    if (this.configureFields.profileUpdateOccupation == 0 && this.configureFields.profileUpdateInterest == 0 && this.configureFields.profileUpdateGeography == 0 &&
                    this.configureFields.profileUpdatePhoneNumber == 0 && this.configureFields.profileUpdateLinkedInUrl == 0
                    ) {
                        this.isUpdateProfileFlag = false;
                        this.isEmailSection = true;
                    }
                    if (this.community.content.referralMessage) {
                        this.referral.message = this.community.content.referralMessage;
                    }
                    if (this.referral.message) {
                        this.countdownReferral();
                    }
                    this.isProfileValidation = this.ask.community.content.profileValidation;
                    this.styleBtn.colorBackdHover = this.community.customSettings.primaryBtnBgColor;
                    this.styleBtn.colorHover = this.community.customSettings.primaryTxtColor;
                    this.styleBtn.colorBackd = this.community.customSettings.secondaryBtnBgColor;
                    this.styleBtn.color = this.community.customSettings.secondaryTxtColor;
                    this.reviewBtn = {
                        border: '1px solid ' + this.community.customSettings.primaryBtnBgColor,
                        color: this.community.customSettings.primaryBtnBgColor
                    };
                    // this.updateProfileBtn = {
                    //     // background: this.community.customSettings.primaryBtnBgColor,
                    //     // color: this.community.customSettings.primaryTxtColor
                    //     background: this.buttonToggle ? this.community.customSettings.primaryBtnBgColor : this.styleBtn.colorBackd,
                    //     color: this.styleBtn.colorHover,
                    // }
                    this.emailBtn = {
                        background: this.community.customSettings.primaryBtnBgColor,
                        color: this.community.customSettings.primaryTxtColor
                    }
                    if (this.community.content.advisorThankYou) {
                        this.advisorThankYou = this.community.content.advisorThankYou;
                    }
                    this.replaceMessage();
                    if (this.memberid) {
                        await this.api.get(`members/${this.memberid}`).then(member => {
                            if (member.data) {
                                this.adviser = member.data;
                                this.memberObj = member.data;
                                this.memberObj.memberRoles = this.memberRoles;
                                this.memberObj.memberskills = this.memberskills;
                                this.frequency = member.data.frequency;
                                if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.interest && this.community.content.configureFields.interest.include === false) {
                                    if (this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                                        if (this.adviser.profileValidationFlag < 5) {
                                            this.adviser.profileValidationFlag = this.adviser.profileValidationFlag + 1;
                                        } else {
                                            this.adviser.profileValidationFlag = 1;
                                        }
                                    }
                                    if (this.enableProfileUpdateList.includes(this.configureFields.profileUpdateInterest)) {
                                        this.enableProfileUpdateList = this.enableProfileUpdateList.filter(e => e !== this.configureFields.profileUpdateInterest);
                                    }
                                }
                                if (this.enableProfileUpdateList.length > 0) {
                                    if (this.enableProfileUpdateList.length == 1) {
                                        this.adviser.profileValidationFlag = this.enableProfileUpdateList[0];
                                    } else if (!this.enableProfileUpdateList.includes(this.adviser.profileValidationFlag)) {
                                        if (this.adviser.profileValidationFlag == 5) {
                                            this.adviser.profileValidationFlag = 1;
                                            if (!this.enableProfileUpdateList.includes(this.adviser.profileValidationFlag)) {
                                                this.adviser.profileValidationFlag = this.nextElement(this.enableProfileUpdateList, this.adviser.profileValidationFlag)
                                            }
                                        } else {
                                            this.adviser.profileValidationFlag = this.nextElement(this.enableProfileUpdateList, this.adviser.profileValidationFlag);
                                        }
                                    }
                                }
                                if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                                    this.isEditing = true;
                                }
                                if (this.adviser && (this.adviser.profileValidationFlag != this.configureFields.profileUpdateInterest && this.adviser.profileValidationFlag != this.configureFields.profileUpdateOccupation && this.adviser.profileValidationFlag != this.configureFields.profileUpdateGeography &&
                                this.adviser.profileValidationFlag != this.configureFields.profileUpdatePhoneNumber && this.adviser.profileValidationFlag != this.configureFields.profileUpdateLinkedInUrl)
                                ) {
                                    this.isUpdateProfileFlag = false;
                                    this.isEmailSection = true;
                                }
                                if (member.data.roles && member.data.roles.length > 0) {
                                    this.memberObj.memberRoles = member.data.roles.toString();
                                }
                                if (member.data.skills && member.data.skills.length > 0) {
                                    this.memberObj.memberskills = member.data.skills.toString();
                                }
                                if (member.data && member.data.first && member.data.last) {
                                    this.referral.adviser.name = `${member.data.first} ${member.data.last}`;
                                }
                                this.referral.adviser.email = member.data && member.data.emails && member.data.emails.length ? member.data.emails[0].trim() : '';
                                this.referral.adviser.id = this.memberid;
                                // this.memberInterestList = this.memberObj.interests;
                                let mergedInterest = [];
                                this.api.get(`configuration/customizations/interests`).then(interests => {
                                    // 6
                                    let refInterest = interests.data.values;
                                    var referanceInterestArr = [];
                                    if (typeof refInterest != 'undefined' && refInterest.length) {
                                        mergedInterest = referanceInterestArr = this.referanceInterest = refInterest;
                                    }
                                    // if (this.memberInterestList) {
                                        var memberRefrenceInterest = referanceInterestArr
                                        mergedInterest = new Map(memberRefrenceInterest.map(s => [s.toLowerCase(), s]));
                                    // }
                                    mergedInterest = [...mergedInterest.values()];
                                    const n = process.env.RANDOM_INTEREST_COUNT;
                                    var shuffled = mergedInterest.sort(function() { return 0.5 - Math.random(); });
                                    this.randomInterest = shuffled.slice(0, n);
                                });
                            } else {
                                this.$router.push('/');
                            }
                        });
                    }
                    setTimeout(function() {
                        document.getElementById("referralName").focus();
                    }, 0);
                    this.createdByMember = this.ask.createdByMemberID;
                    this.findMemberSchool(this.createdByMember._id);
                } else {
                    this.$router.push('/');
                }
            });
    	},
        changeEmailFrequency(frequency) {
            this.adviser.frequency = frequency;
        },
        async updateEmailFrequency() {
            if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
                this.api.post(`members/${this.memberid}/update-email-frequency`, {frequency: this.adviser.frequency})
                .then(response => {
                    let frequency = '';
                    if (this.adviser.frequency === 'as often as needed') {
                        frequency = 'All';
                    } else if (this.adviser.frequency === 'daily') {
                        frequency = 'Daily';
                    } else if (this.adviser.frequency === 'once a week') {
                        frequency = 'Weekly';
                    } else if (this.adviser.frequency === 'once a month') {
                        frequency = 'Monthly';
                    } else if (this.adviser.frequency === 'once a quarter') {
                        frequency = 'Quarterly';
                    }
                    if (typeof this.memberid !== 'undefined' && this.memberid !== 'null' && frequency) {
                        document.title = 'Thank You';
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': this.ask._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': this.ask.community.name,
                            'MemberID': this.memberid,
                            'MemberRole': 'Advisor',
                            'AskFrequency': frequency,
                            'event': 'MemberAdjustAskFrequency'
                        });
                    }
                });
                if (this.advisorThankYou) {
                    window.open(this.advisorThankYou, '_self');
                } else {
                    this.emailUpdate = true;
                }
            } else {
                let status = 'reject';
                if (this.ask.status === '(7) Closed') {
                    status = 'close';
                }
                this.$toast.error(`Request is ${status} so you can't not add response`);
            }
        },
        submitReferral: async function(scope) {
			var parameters = {};
    	       this.$validator.validateAll(scope).then(async result => {
    		    if (result) {
                    if (this.$route.query.location === 'dashboard') {
                        this.isUpdateProfileFlag = false;
                        // document.title = 'Thank You';
                    }
                    else if (this.isUpdateProfileFlag) {
                        console.log("this is also running")
                        document.title = 'Update Your Information';
                    } else {
                        document.title = 'Thank You';
                    }
                    this.success = true;
                    this.successReferral = true;
                    if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                        this.isEditing = true;
                    }
                    window.scrollTo(0, 0);
                    await this.getGiveId();
                    parameters = {
                        askId: this.askid,
                        giveId: this.giveId,
                        referral: this.referral,
                        memberId: this.memberid,
                        profileUpdateFlag: this.adviser.profileValidationFlag
                    }
					await this.api
					.post(`referral-request`, parameters)
					.then(response => {
                        if (this.isUpdateProfileFlag) {
                            document.title = 'Update Your Information';
                        } else {
                            document.title = 'Thank You';
                        }
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': this.ask._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': this.ask.community.name,
                            'MemberID': this.memberid,
                            'MemberRole': 'Advisor',
                            'event': 'MemberShareRequest'
                        });
					});
				} else {
                    const errorElements = document.querySelectorAll('.error');
                    if (errorElements.length > 0) {
                        let isFirstErrorFocused = false;
                        for (let errorElement of errorElements) {
                            if (errorElement.style.display !== 'none') {
                                let inputElement = errorElement.previousElementSibling;
                                while (inputElement) {
                                    if ((inputElement.tagName === 'INPUT' || inputElement.tagName === 'SELECT' || inputElement.tagName === 'TEXTAREA') && !isFirstErrorFocused) {
                                        inputElement.focus();
                                        errorElement.setAttribute('aria-live', 'assertive');
                                        errorElement.setAttribute('role', 'alert');
                                        let message = '';
                                        message = errorElement.innerText;
                                        this.errorAnnouncement(message);
                                        isFirstErrorFocused = true;
                                        break;
                                    }
                                    inputElement = inputElement.previousElementSibling;
                                }
                            }
                        }
                    }
                }
			});
		},
        errorAnnouncement(message) {
              const liveRegion = document.createElement('div');
              liveRegion.setAttribute('aria-live', 'polite');
              liveRegion.setAttribute('role', 'alert');
              liveRegion.innerText = message;
              document.body.appendChild(liveRegion);
              setTimeout(() => {
                  liveRegion.remove();
              }, 1000);
          },
        getGiveId: async function() {
            let parameters = {
                advisors: [this.memberid],
                action: 'Not Available',
                help: 'request-help',
                helpaction: 'no'
            };
            await this.api
            .post(`asks/${this.ask._id}/request-help`, parameters)
            .then(response => {
                if (response.data.giveId) {
                    this.giveId = response.data.giveId;
                }
            });
        },
    	countdownReferral: function() {
            this.remainingCountReferral = this.maxReferral - this.referral.message.length;
            this.remainingCountReferral === 0
            ? (this.exceedsMaxCountReferral = true)
            : (this.exceedsMaxCountReferral = false);
        },
        replaceMessage() {
            if (this.referral && this.referral.message) {
                // var regexPattern = new RegExp("{{ community.name }}", 'i');
                let regexPattern = new RegExp(`\\{\\{\\s?community.name\\s?\\}\\}`, 'gi');
                if (this.community && this.community.name) {
                    this.referral.message = sanitizeInput(
                        this.referral.message.replace(regexPattern, sanitizeInput(this.community.name))
                    );
                } else {
                    this.referral.message = sanitizeInput(this.referral.message.replace(regexPattern, ''));
                }
            }
        },
        clickUpdateProfile() {
            if (typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
                this.$gtm.enable(true)
                this.$gtm.trackEvent({
                    'RequestID': this.ask._id,
                    'RequestSource': 'Web',
                    'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                    'Community': this.ask.community.name,
                    'MemberID': this.memberid,
                    'MemberRole': 'Advisor',
                    'event': 'MemberClickUpdateProfile'
                });
            }
        },
        editProfile: function() {
            this.isEditing = true;
        },
        getCookie(name) {
            let matches = document.cookie.match(new RegExp(name + '=([^;]+)'));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        updateLinkedinProfile() {
            let memberUpdateData = {
                requestId: this.ask._id,
                giveId: this.giveId,
                communityId: this.community._id,
                community: this.community.name,
                memberId: this.adviser._id,
                propertyId: this.adviser.propertyId,
                name: this.adviser.displayName,
                email: this.adviser.emails.toString(),
                communityCustomSettings: this.community.customSettings,
                communityContentParameter2: this.community.content.parameter2,
                communityContentLandingPageURL: this.community.content.landingPageURL,
                communityContentTermsConditionsURL: this.community.content.termsConditionsURL,
                communityContentUnsubscribePageURL: this.community.content.unsubscribePageURL
            };

            if (this.getCookie("memberUpdateData")) {
                document.cookie = "memberUpdateData=" + JSON.stringify(memberUpdateData) + "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
            let clientId = this.community.linkedinCredentials && this.community.linkedinCredentials.clientId ? this.community.linkedinCredentials.clientId : process.env.LINKEDIN_CLIENT_ID
            let linkedInRedirectURI = process.env.LINKEDIN_REDIRECT_URI;
            let linkedInStateKey = process.env.LINKEDIN_STATE_KEY;

            document.cookie = "memberUpdateData=" + JSON.stringify(memberUpdateData) + ";expires=" + (new Date(this.$moment().utc().add(5, 'minutes').toDate())).toUTCString() + ";path=/";

            window.location.href = `https://www.linkedin.com/oauth/v2/authorization/?response_type=code&client_id=${clientId}&redirect_uri=${linkedInRedirectURI}&state=${linkedInStateKey}&scope=r_liteprofile%20r_emailaddress`;
        },
        saveChanges: function() {
            this.infoHasChanged = true;
        },
        saveProfile: async function(booleanVal = true) {
            this.buttonToggle = false;
            const memberUpdateData = {
                requestId: sanitizeInput(this.ask._id),
                communityId: sanitizeInput(this.community._id),
                community: sanitizeInput(this.community.name),
                memberId: sanitizeInput(this.adviser._id),
                propertyId: sanitizeInput(this.adviser.propertyId),
                name: sanitizeInput(this.adviser.displayName),
                email: sanitizeInput(this.adviser.emails.toString().toLowerCase()),
                memberObj: {
                    ...this.memberObj,
                    memberRoles: sanitizeInput(this.memberObj.memberRoles),
                    organization: sanitizeInput(this.memberObj.organization),
                    city: sanitizeInput(this.memberObj.city),
                    state: sanitizeInput(this.memberObj.state),
                    country: sanitizeInput(this.memberObj.country)
                }
            };
            // delete memberUpdateData.memberObj.interests;
            if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                console.log("this.adviser", this.adviser)
                const existingInterests = memberUpdateData.memberObj.interests || [];
                const newInterests = this.selectedInterestList || [];
                memberUpdateData.memberObj.interests = [...new Set([...existingInterests, ...newInterests])];
            } else {
                delete memberUpdateData.memberObj.interests;
            }
            if (this.adviser && this.adviser.profileValidationFlag != this.configureFields.profileUpdateInterest) {
                //this.isEditing = false;
            }
            await this.api.post(`members/profile-update`, memberUpdateData).then(response => {
                this.clickUpdateProfile();
                this.adviser = this.memberObj;
                if (this.infoHasChanged) {
                    this.$refs.snackbar.open('Thank you. You have successfully updated your profile.');
                }
                this.buttonToggle = true;
            });
        },
        /*outside: function(e) {
            this.isEditing = false;
        },*/
        closeBtn: function() {
            window.open('', '_parent', '');
            window.close();
        },
        goToNext: async function() {
            this.saveProfile(false);
            window.scrollTo(0, 0);
            document.title = 'Thank You';
            this.isEmailSection = true;
            this.successMsg = `Would you like to help more?`;
        },
        nextElement: function(arr, target) {
            let start = 0;
            let end = arr.length - 1;
            let ans = -1;
            while (start <= end) {
                let mid = parseInt((start + end) / 2, 10);
                if (arr[mid] <= target) {
                    start = mid + 1;
                } else {
                    ans = mid;
                    end = mid - 1;
                }
            }
            return typeof arr[ans] == 'undefined' ? arr[0] : arr[ans];
        },
        checkMemberStatus: function(email) {
            let params = {
                email: email,
                community_id: this.ask.community._id
            }
            this.api.post(`communities/${this.ask.community._id}/get-member-details/`, params)
                .then(async member => {
                    if (member.data._id) {
                        if (member.data.unsubscribe) {
                            this.memberExists = false;
                        } else {
                            this.memberExists = true;
                        }
                        this.referral.recipient.id = member.data._id;
                    }
            });
        },
        findMemberSchool: async function(memberId) {
            await this.api.get(`members/${memberId}`).then(member => {
                    if (member.data._id) {
                        this.memberSchool = member.data.school1;
                    }

                })
        }
      }
    };
</script>

<style scoped>
.email-actionpage .feedback_container .flex-button-child.theme-btn {
  color: var(--styleBtn-color);
  background-color: var(--styleBtn-background-color);
}

.email-actionpage .feedback_container .flex-button-child.theme-btn:hover {
  color: var(--styleBtn-color--hover);
  background-color: var(--styleBtn-background-color--hover);
}

.submitBtn {
  color: var(--styleBtn-color) !important;
  background-color: var(--styleBtn-background-color) !important;
}
.submitBtn:hover {
  color: var(--styleBtn-color--hover) !important;
  background-color: var(--styleBtn-background-color--hover) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ShareRequest.vue